
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Sieben bis acht Stunden Schlaf, flauschige Träume, möglichst ohne aufzuwachen: Sieht so die einzig wahre Nachtruhe aus? Nein, sagen Forscher von der Duke University in Durham, die den Schlaf eines Naturvolks in Tansania beobachtet haben. Ihr Schlaf war längst nicht so störungsfrei wie der, den wir als natürlich erachten. Im Mittel gingen die Hadza – so der Name des Volkes – gegen 22 Uhr ins Bett und wachten gegen 7 Uhr auf. Ihr Schlafverhalten war allerdings ziemlich unterschiedlich und hatte sich innerhalb der Gruppe nicht synchronisiert. `}<M mdxType="M">{`Während der gesamten Nachtzeit gab es nur wenige Episoden von gerade mal einer Minute Dauer, in der alle Mitglieder der Gruppe gleichzeitig schliefen.`}</M>{` Einige schliefen zunächst tief und fest für ein paar Stunden, andere wachten schon bald nach dem Einschlafen wieder auf und verliessen sogar kurz ihr Lager. Manche legten sich früh hin, andere viel später. `}<br /><br />{`
Für die Forscher ist diese Beobachtung ein Grund zur Beruhigung: Wer nachts häufig aufwacht, muss dies aus ihrer Sicht nicht zwingend als Schlafstörung betrachten, sondern vielleicht auch als Überbleibsel aus einer früheren Phase unserer Evolution. Denn dieses Verhalten war früher durchaus von Vorteil: So konnten die Wachen Wache halten und die Schlafenden vor Raubtieren oder Überfällen schützen.`}</p>
    <p>{`Auch scheinen Schlafstörungen kein modernes Phänomen zu sein. Das «British Medical Journal» schrieb schon 1894: `}<M mdxType="M">{`«Die Hetzerei und Nervosität des modernen Lebens werden völlig zu Recht für das grosse Ausmass der Schlaflosigkeit verantwortlich gemacht.»`}</M></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;